export const ChevronRightSmIcon = ({
  color = '#212124',
  size = 16,
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M4.793 12.293a1 1 0 101.414 1.414l-1.414-1.414zM10.5 8l.707.707a1 1 0 000-1.414L10.5 8zM6.207 2.293a1 1 0 00-1.414 1.414l1.414-1.414zm0 11.414l5-5-1.414-1.414-5 5 1.414 1.414zm5-6.414l-5-5-1.414 1.414 5 5 1.414-1.414z"
        fill={color}
      />
    </svg>
  );
};
